import { render, staticRenderFns } from "./ParamsMenu.vue?vue&type=template&id=3f20c3f9&scoped=true&"
import script from "./ParamsMenu.vue?vue&type=script&lang=js&"
export * from "./ParamsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f20c3f9",
  null
  
)

export default component.exports